








































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { CreateElement, VNode } from 'vue';
import {
  SwTreeList,
  SwTreeListItem,
  ItemExpandRequestData,
  ItemSelectRequestData,
} from '@libs-uuif/shared/sw-tree-list';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import { SwBadge } from '@libs-uuif/shared/sw-badge';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { FwStatusFlag } from '@/shared/fw-status-flag';
import { utilService } from '@libs-uuif/shared/util-service';
import { DeviceHierarchy } from '@/shared/types/device-hierarchy.types';
const cssPrefix = 'device-picker-hierarchy';
export const allTenantNode: DeviceHierarchy = {
  id: 'all-tenant',
  label: 'All Tenants',
  type: 'tenant',
  data: {},
  isDefault: false,
  subtotal: 0,
  children: [],
};

/**
 * Similar with `wcm-hierarchy-block`, but has different styles and operations.
 * Will be reusing some parts of `wcm-hierarchy-block`.
 * @event request-select `(ItemSelectRequestData)`
 * @event request-expand `(ItemExpandRequestData)`
 */

@Component({
  components: {
    SwTreeList,
    SwTreeListItem,
    SwIcon,
    SwBadge,
    SwScrollView,
  },
  directives: {
    tooltip,
  },
})
export default class DevicePickerHierarchy extends SwExtendedVue {
  @Prop({ type: Array, required: true })
  devicePickerTreeData: DeviceHierarchy[];

  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  selected: string[];

  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  expanded: string[];

  @Prop({ type: Boolean, default: true, required: false })
  showAllTenantsNode: boolean;
  cssPrefix = cssPrefix;

  showHaStatus(hierarchyItem: DeviceHierarchy): boolean | string {
    if (
      !hierarchyItem ||
      hierarchyItem.type !== 'device' ||
      !hierarchyItem.data.highAvailability ||
      !hierarchyItem.data.highAvailability.activeSerialNumber
    ) {
      return false;
    }
    return hierarchyItem.data.highAvailability.activeSerialNumber ===
      hierarchyItem.id
      ? 'P'
      : 'S';
  }

  disableTreeItem(hierarchyItem: DeviceHierarchy): boolean {
    return (
      hierarchyItem.type === 'device' && hierarchyItem.data.acquireStatus !== 3
    );
  }
  generateChildTree(
    h: CreateElement,
    hierarchyItem: DeviceHierarchy,
  ): VNode | null {
    // tslint:disable-line
    if (!hierarchyItem) {
      return null;
    }
    let childNodes: (VNode | null)[] = [];
    if (hierarchyItem.children && hierarchyItem.children.length >= 0) {
      childNodes = hierarchyItem.children.map(
        (childHierarchyItem: DeviceHierarchy) => {
          return this.generateChildTree(h, childHierarchyItem);
        },
      );
    }
    const rootNode = (
      <sw-tree-list-item
        class={[
          hierarchyItem.type === 'device' &&
          hierarchyItem.data.acquireStatus !== 3
            ? `${cssPrefix}__listItem--disabled`
            : '',
        ]}
        key={hierarchyItem.id || ''}
        itemId={hierarchyItem.id || ''}
        {...{
          scopedSlots: {
            pre: () => (
              <div class={[`${cssPrefix}__item-icon`]}>
                <sw-icon
                  name={this.getItemIcon(hierarchyItem)}
                  size={16}
                  as-block
                  style={{ color: '#c9c9c9', marginRight: '5px' }}
                />
              </div>
            ),
            label: () => (
              <div style={{ width: '40%' }}>
                <span>{hierarchyItem.label}</span>
              </div>
            ),
            dangle: () => {
              const node: VNode[] = [];
              const haStatus: boolean | string = this.showHaStatus(
                hierarchyItem,
              );
              if (haStatus) {
                node.push(
                  (
                    <FwStatusFlag
                      v-tooltip={{
                        content: `${
                          haStatus === 'P' ? 'Primary' : 'Secondary'
                        }`,
                        placement: 'top',
                        compact: true,
                      }}
                      class={[`${this.cssPrefix}__ha-status`]}
                      haStatus={haStatus}
                      backgroundColor={'#99cc00'}
                    />
                  ) as VNode,
                );
              }
              if (
                hierarchyItem.type === 'device' &&
                hierarchyItem.data.acquireStatus !== undefined
              ) {
                node.push(
                  (
                    <SwIcon
                      name={'dot'}
                      size={'xsmall'}
                      v-tooltip={(() => {
                        let tooltipMessage: string = 'Offline';
                        if (
                          hierarchyItem.data.liveStatus &&
                          hierarchyItem.data.synchronized
                        ) {
                          tooltipMessage = 'Online & Managed';
                        } else if (
                          hierarchyItem.data.liveStatus &&
                          !hierarchyItem.data.synchronized
                        ) {
                          tooltipMessage = 'Online & Unmanaged';
                        }
                        return {
                          compact: true,
                          placement: 'right',
                          content: tooltipMessage,
                        } as TooltipDirValues;
                      })()}
                      color={(() => {
                        if (
                          hierarchyItem.data.liveStatus &&
                          hierarchyItem.data.synchronized
                        ) {
                          return utilService.colorConst.statusNormal;
                        }
                        if (
                          hierarchyItem.data.liveStatus &&
                          !hierarchyItem.data.synchronized
                        ) {
                          return utilService.colorConst.statusMajor;
                        }
                        return utilService.colorConst.statusCritical;
                      })()}
                    />
                  ) as VNode,
                );
              }
              return (
                <div class={['sw-flexbox', 'sw-flexbox--center-items']}>
                  {node}
                </div>
              );
            },
          },
        }}
      >
        {childNodes}
      </sw-tree-list-item>
    );
    return rootNode as VNode;
  }
  geenrateParentTree(h: CreateElement): VNode[] {
    // tslint:disable-line
    return this.devicePickerTreeData.map<VNode>(
      (pickedItem: DeviceHierarchy) => {
        const childNodes: VNode | null = this.generateChildTree(h, pickedItem);
        const nodeObj = (
          <sw-tree-list
            style={{ width: '300px' }}
            selected={this.selected}
            expanded={this.expanded}
            item-overflow={false}
            trigger-style="plus-minus"
            on-request-select={this.onSelectItem}
            on-request-expand={this.onExpandItem}
            indent={10}
          >
            {childNodes}
          </sw-tree-list>
        ) as VNode;
        return nodeObj;
      },
    );
  }
  private onExpandItem(data: ItemExpandRequestData) {
    this.$emit('request-expand', data);
  }
  private onSelectItem(data: ItemSelectRequestData) {
    this.$emit('request-select', data);
  }
  private getItemIcon(item: DeviceHierarchy) {
    if (item && item !== null) {
      if (item.type === 'tenant') {
        return 'service-msw';
      }
      if (item.type === 'group') {
        return 'double-group';
      }
      if (item.type === 'device') {
        return 'firewall';
      }
    }
    return '';
  }
  // getDeviceAcquireStatus(aquired: string) {
  //   return deviceAcquiringStatus[aquired];
  // }
  getTreeItemTooltip(hierarchyItem: DeviceHierarchy) {
    if (hierarchyItem && hierarchyItem !== null) {
      if (hierarchyItem.type === 'device') {
        return {
          content: '',
          compact: true,
          doAnimation: true,
        } as TooltipDirValues;
      }
    }
  }
  private render(h: CreateElement): VNode {
    // tslint:disable-line
    if (this.devicePickerTreeData.length <= 0) {
      return (
        <SwScrollView class={[`${this.cssPrefix}__scroll`]} theme="dark">
          <div
            class={[
              'sw-flexbox',
              'sw-flexbox--center-items',
              'sw-flexbox--center-justify',
            ]}
            style={{ height: '100%' }}
          >
            <span class={[`${this.cssPrefix}__no-data`]}>{'No Data'}</span>
          </div>
        </SwScrollView>
      ) as VNode;
    }
    let treeNodes: (VNode | null)[] = [];
    if (this.devicePickerTreeData && this.devicePickerTreeData !== null) {
      treeNodes = this.devicePickerTreeData.map(
        (hierarchyItem: DeviceHierarchy) => {
          return this.generateChildTree(h, hierarchyItem);
        },
      );
    }
    const root = (
      <div class={[`${this.cssPrefix}`, 'sw-flexbox']}>
        <div class={['sw-flexbox__flex-none']}>
          {(() => {
            if (this.showAllTenantsNode) {
              return (
                <div
                  class={[
                    `${this.cssPrefix}__root`,
                    `${this.cssPrefix}__root--all-tenant`,
                    {
                      [`${this.cssPrefix}__root--selected`]: this.selected.includes(
                        allTenantNode.id,
                      ),
                    },
                    'sw-flexbox',
                    'sw-flexbox--center-items',
                  ]}
                  style={{ cursor: 'pointer' }}
                  on-click={() => {
                    const allTenant: DeviceHierarchy = Object.assign(
                      {},
                      allTenantNode,
                    );
                    this.$emit('all-tenant', allTenant);
                  }}
                >
                  <sw-icon
                    name={'group'}
                    size={16}
                    as-block
                    style={{ color: '#c9c9c9', marginRight: '5px' }}
                  />
                  <span
                    class={[`${this.cssPrefix}__root-desc`, 'sw-flexbox__flex']}
                  >
                    {'All Tenants'}
                  </span>
                </div>
              );
            }
          })()}
          <sw-tree-list
            style={{ width: '300px' }}
            selected={this.selected}
            expanded={this.expanded}
            item-overflow={false}
            trigger-style="plus-minus"
            on-request-select={this.onSelectItem}
            on-request-expand={this.onExpandItem}
            indent={10}
          >
            {treeNodes}
          </sw-tree-list>
        </div>
      </div>
    );
    return root as VNode;
  }
}
